<template>
  <div :class="prefixCls">
    <Row :gutter="15">
      <Col :span="second ? 12 : 8">
        <Select
          name="province"
          @on-change="changeProvince"
          v-model="provinceId"
          placeholder="请选择省份"
        >
          <Option :value="p.id" :key="p_index" v-for="(p, p_index) in addressData">{{p.name}}</Option>
        </Select>
      </Col>
      <Col :span="second ? 12 : 8">
        <Select name="city" v-model="cityId" @on-change="changeCity" placeholder="请选择城市">
          <Option :value="c.id" :key="c_index" v-for="(c, c_index) in cityData">{{c.name}}</Option>
        </Select>
      </Col>
      <Col v-if="!second" span="8">
        <Select
          name="zone"
          v-model="address.locationId"
          @on-change="changeRegion"
          placeholder="请选择区域"
        >
          <Option :value="z.id" :key="z_index" v-for="(z, z_index) in zoneData">{{z.name}}</Option>
        </Select>
      </Col>
    </Row>
  </div>
</template>

<script>
const prefixCls = "zAddress";
export default {
  name: "ZAddress",
  data() {
    return {
      prefixCls: prefixCls,
      address: {
        locationId: "",
        detailAddress: "",
        cityAddress: "",
        doorAddress: "",
        userName: "",
        userMobile: "",
        isDefault: 0,
        zipCode: "200070",
        id: ""
      },
      changeProvice: false,
      provinceId: "",
      cityId: "",
      addressData: [],
      cityData: [],
      zoneData: []
    };
  },
  props: {
    // address: {
    //   type: Array,
    //   default: function() {
    //     return [];
    //   }
    // },
    addressId: {
      type: [Number, String],
      default: ""
    },
    second: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "addressId",
    event: "getAddressIdHandle"
  },
  methods: {
    getAddress() {
      if (localStorage && localStorage.getItem) {
        let list = JSON.parse(localStorage.getItem("vuejs__ZHULOGIC_ADDRESS"))
          .value;
        this.addressData = list;
      } else {
        this.addressData = this.address;
      }
      this.initLocation();
    },

    initLocation() {
      this.address.locationId = this.addressId || "";
      if (!this.address.locationId) {
        return;
      }
      this.addressData.forEach(province => {
        province.cities.forEach(city => {
          if (this.second) {
            if (city.id === this.address.locationId) {
              this.provinceId = province.id;
              this.cityData = province.cities;
              this.cityId = city.id;
            }
          } else {
            city.cities.forEach(zone => {
              if (zone.id === this.address.locationId) {
                this.provinceId = province.id;
                this.cityData = province.cities;
                this.cityId = city.id;
                this.zoneData = city.cities;
              }
            });
          }
        });
      });
    },
    changeProvince(pid) {
      this.addressData.forEach(province => {
        if (province.id === pid) {
          this.changeProvice = !this.changeProvice;
          this.cityData = province.cities;
          this.zoneData = [];
          this.cityId = "";
          this.address.locationId = "";
          this.changeRegion();
        }
      });
    },
    changeCity(cid) {
      this.cityData.forEach(city => {
        if (city.id === cid) {
          this.changeProvice = !this.changeProvice;
          if (this.second) {
            this.address.locationId = city.id;
            this.changeRegion();
          } else {
            this.zoneData = city.cities;
            this.address.locationId = "";
          }
        }
      });
    },

    // thorw out
    changeRegion() {
      this.$emit("getAddressIdHandle", this.address.locationId);
    }
  },

  watch: {
    addressId: function() {
      this.initLocation();
    }
  },

  mounted() {
    this.getAddress();
  }
};
</script>

